import {RouteConfig} from 'vue-router'
import DashboardLayout from '@/components/Dashboard/Layout/DashboardLayout.vue'
import wikiList from '@/pages/wiki/wikiList.vue'
import wikiPageCreate from '@/pages/wiki/wikiPageCreate.vue'
import wikiNodeCreate from '@/pages/wiki/wikiNodeCreate.vue'
import wikiPage from '@/pages/wiki/wikiPage.vue'
import wikiPageEdit from '@/pages/wiki/wikiPageEdit.vue'
import wikiNodeEdit from '@/pages/wiki/wikiNodeEdit.vue'
import {USER_ROLE_WIKI} from '@/constants'

// @ts-ignore
import messages from '@/lang/index';

const wiki: RouteConfig = {
  path: '/wiki',
  name: 'wiki',
  meta: {
    pageName: messages.wiki.page_name
  },
  component: DashboardLayout,
  redirect: '/wiki/list',
  children: [
    {
      path: 'list',
      name: 'wikiList',
      meta: {
        pageName: messages.wiki.list_page_name
      },
      component: wikiList
    },
    {
      path: 'createPage',
      name: 'wikiPageCreate',
      meta: {
        pageName: messages.wiki.create_page_name,
        access: USER_ROLE_WIKI
      },
      component: wikiPageCreate
    },
    {
      path: 'createNode',
      name: 'wikiNodeCreate',
      meta: {
        pageName: messages.wiki.create_node_name,
        access: USER_ROLE_WIKI
      },
      component: wikiNodeCreate
    },
    {
      path: '/wiki/:id',
      name: 'wikiPage',
      meta: {
        pageName: messages.wiki.single_page_name
      },
      component: wikiPage,
      props: true
    },
    {
      path: 'editPage/:id',
      name: 'wikiPageEdit',
      meta: {
        pageName: messages.wiki.edit_page_name,
        access: USER_ROLE_WIKI
      },
      component: wikiPageEdit,
      props: true
    },
    {
      path: 'editNode/:id',
      name: 'wikiNodeEdit',
      meta: {
        pageName: messages.wiki.edit_node_name,
        access: USER_ROLE_WIKI
      },
      component: wikiNodeEdit,
      props: true
    }
  ]
}
export default wiki;